import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { handleUserRedirect } from '../../../utils/userRedirect';

import LoadingScreen from '../../system/loading_screen';

const AdminSessionRedirect = ({ currentUser }) => {
  const history = useHistory();

  useEffect(() => {
    if (!currentUser?.id) return;

    handleUserRedirect(currentUser, history, { isImpersonation: true });
  }, [currentUser, history]);

  return <LoadingScreen />;
};

export default AdminSessionRedirect;
